import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from 'dpl/common/components/Icon';

import { SCORECARD_SECTION_ID } from '../utils/constants';

const ICON_PROPS = {
  name: 'jump-to-arrow',
  height: '40px',
  width: '40px'
};

export default function JumpToScorecardButton({ className, iconPosition }) {
  return (
    <button
      type="button"
      className={classnames('flex items-center', className)}
      onClick={() => {
        const el = document.getElementById(SCORECARD_SECTION_ID);
        el?.scrollIntoView({ behavior: 'smooth' });
      }}
    >
      {iconPosition === 'left' && <Icon {...ICON_PROPS} className="mr4" />}
      Jump to full scorecard
      {iconPosition === 'right' && <Icon {...ICON_PROPS} className="ml3" />}
    </button>
  );
}

JumpToScorecardButton.propTypes = {
  className: PropTypes.string,
  iconPosition: PropTypes.oneOf(['left', 'right']).isRequired
};

JumpToScorecardButton.defaultProps = {
  className: null
};
